<template>
    <report-page
        :title="name"
        :data-to-send="dataToSend"
        :buttons-disabled="buttonsDisabled"
        :history-filter="historyFilter"
        :selectedWorkspaceUUID="selectedWorkspace"
    >
        <template v-slot:reportForm>
            <report-field :field-name="$tc('Workspace', 1)">
                <treeselect
                    v-model="selectedWorkspace"
                    @select="selectedWorkspaceGeom = $event.geom"
                    :options="workspaceOptions"
                    :disabled="
                        !hasPermissionToCreateExport ||
                        workspaceSelectionDisabled ||
                        !userHasManagementPermission('workspace', 'list')
                    "
                    disableFuzzyMatching
                />
            </report-field>
            <report-field>
                <v-radio-group v-if="objects.object.length > 0 || objects.geom" v-model="radioGroup" row id="radio-label-spacing">
                    <v-radio v-if="objects.object.length > 0" label="Network" value="network" color="accent" />
                    <v-radio v-if="objects.geom" label="Workspace" value="workspace" color="accent"/>
                </v-radio-group>
            </report-field>
            <report-field
                v-if="radioGroup === 'network' && objects.object.includes('technical_local')"
                :field-name="$t(reportParameters[0].label)"
            >
                <treeselect
                    v-model="reportParameters[0].value"
                    @input="resetClosureOptions"
                    :options="networkStartingPointOptions"
                    :load-options="getNetworkStartingPointOptions"
                    :disabled="
                        !hasPermissionToCreateExport ||
                        technicalSiteLocalDisabled ||
                        !userHasPermissionToList('technical_local')
                    "
                    :disable-branch-nodes="true"
                    disableFuzzyMatching
                />
            </report-field>
            <report-field
                v-if="radioGroup === 'network' && objects.object.includes('closure')"
                :field-name="$tc(reportParameters[1].label, 1)"
            >
                <treeselect
                    v-model="reportParameters[1].value"
                    :options="closureOptions"
                    :load-options="loadClosureOptions"
                    :disabled="
                        !hasPermissionToCreateExport ||
                        technicalSiteLocalDisabled ||
                        !userHasPermissionToList('closure')
                    "
                    :normalizer="normalizer"
                    :disable-branch-nodes="true"
                    disableFuzzyMatching
                />
            </report-field>
            <report-field
                v-for="name in extraDataNames"
                :key="name"
                :field-name="getLabel(name)"
            >
                <treeselect
                    v-if="extraData[name].type === 'select' || extraData[name].type === 'treeselect'"
                    v-model="extraData[name].value"
                    :options="extraData[name].list"
                    :disabled="!hasPermissionToCreateExport"
                    :multiple="extraData[name].type === 'treeselect'"
                />
                <input
                    v-else v-model="extraData[name].value"
                    :type="extraData[name].type"
                />
            </report-field>
        </template>
    </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";
import { mapActions } from "vuex";
export default {
    name: "CustomReport",

    components: {
        ReportField,
        ReportPage
    },

    mixins: [homeReportPageMixin],

    props: {
        name: {
            type: String,
            required: true
        },
        version: {
            type: String
        },
        customJson: {
            type: String
        }
    },

    data() {
        return {
            objects: {
                object : []
            },
            extraData: {},
            extraDataNames: [],
            radioGroup: null,
            selectedWorkspaceGeom: null,
            reportParameters: [
                {
                    label: "NetworkStartingPoint",
                    key: "technical_local",
                    type: "text",
                    value: undefined
                },
                {
                    label: "Closure",
                    key: "closure",
                    type: "text",
                    value: undefined
                }
            ],
            historyFilter: "tdf_exportation",
            companyUuid: null

        };
    },

    computed: {
        /**
         * Determines if report buttons are disabled
         * @returns {boolean}
         */
        buttonsDisabled() {
            let isDisabled;
            let requiredDataIsEmpty = {
                fieldsAreRequired: false
            };
            if(this.radioGroup === "network"){
                isDisabled = !(!!this.reportParameters[0].value || !!this.reportParameters[1].value)
            }else if (this.radioGroup === "workspace"){
                isDisabled = false;
            }else{
                isDisabled = false;
            }
            if(this.extraDataNames.length > 0){
                requiredDataIsEmpty = this.requiredExtraDataIsEmpty();
            }
            return isDisabled || (requiredDataIsEmpty.fieldsAreRequired ? requiredDataIsEmpty.isEmpty : false);
        },
        technicalSiteLocalDisabled() {
            return this.selectedWorkspace === undefined;
        },
        dataToSend() {
            let data = {
                type: this.historyFilter,
                version: this.version,
                company_uuid: this.companyUuid
            };
            if (this.reportParameters[0].value) {
                let objects;
                if(this.objects.workspace_uuid){
                    objects = {
                        workspace_uuid: this.selectedWorkspace,
                        object: {
                            uuid: this.reportParameters[0].value,
                            object_type: this.reportParameters[0].key
                        }
                    };
                }else{
                    objects = {
                        object: {
                            uuid: this.reportParameters[0].value,
                            object_type: this.reportParameters[0].key
                        }
                    };
                }
                data= {...data, objects}
            }
            if (this.reportParameters[1].value) {
                let objects;
                if(this.objects.workspace_uuid){
                    objects = {
                        workspace_uuid: this.selectedWorkspace,
                        object: {
                            uuid: this.reportParameters[1].value,
                            object_type: this.reportParameters[1].key
                        }
                    };
                }else{
                    objects = {
                        object: {
                            uuid: this.reportParameters[1].value,
                            object_type: this.reportParameters[1].key
                        }
                    };
                }
                data= {...data, objects}
            }
            if (this.radioGroup === "workspace") {
                let objects;
                if(this.objects.workspace_uuid){
                    objects = {
                        workspace_uuid: this.selectedWorkspace,
                        geom: this.selectedWorkspaceGeom
                    };
                }else{
                    objects = {
                        geom: this.selectedWorkspaceGeom
                    };
                }
                data= {...data, objects}
            }
            if(this.radioGroup === null && this.objects.workspace_uuid){
                const objects = {
                    workspace_uuid: this.selectedWorkspace,
                };
                data= {...data, objects}
            }
            if(Object.keys(this.extraData).length > 0){
                const keyValueArray = [];
                this.extraDataNames.forEach(name => {
                    if(this.extraData[name].value){
                        keyValueArray.push([name, this.extraData[name].value])
                    }
                });
                if(keyValueArray.length > 0){
                    const obj = Object.fromEntries(keyValueArray);
                    data = {...data, extra_data: obj}
                }
            }
            return data;
        }
    },

    watch: {
        selectedWorkspace() {
            this.resetReportParameterValues(this.reportParameters, 0);
            this.networkStartingPointOptions = null;
            this.closureOptions = null;
        }
    },

    mounted() {
        this.getAllData();
        this.setWorkspaceField();
    },

    methods: {
        ...mapActions([
            "GET_ALL_OBJECTS_IN_GIVEN_WORKSPACE",
            "GET_TECHNICAL_LOCAL_WITH_LOGICAL_RELATIONS",
            "getCustomReportListOptions"
        ]),
        /**
         * reset closure options and the field where the value of the selected closure is stored
         */
        resetClosureOptions() {
        this.resetReportParameterValues(this.reportParameters, 1);
        this.closureOptions = null;
        },
        async getAllData(){
            this.companyUuid = window.localStorage.getItem('company_uuid');
            if(this.customJson){
                const workspace_uuid = sessionStorage.getItem('workspace_uuid');
                const json = JSON.parse(this.customJson);
                //set radioGroup value
                this.setRadioGroupValue(json.objects);
                this.objects = json.objects;
                const objEntries = Object.keys(json.extra_data);
                objEntries.forEach(entry =>{
                    json.extra_data[entry] = {...json.extra_data[entry], value: json.extra_data[entry].default_value}
                });
                this.extraData = {...json.extra_data};
                if(objEntries.length > 0){
                    for(let i = 0; i < objEntries.length; i++){
                        await this.getSelectOptions(workspace_uuid,objEntries[i], json.extra_data[objEntries[i]]);
                    }
                    this.extraDataNames = [...objEntries];
                }
            }
        },
        setRadioGroupValue(objects){
            if(objects.object.length > 0){
                this.radioGroup = "network"
            }else if(objects.geom){
                this.radioGroup = "workspace"
            }
        },
        async getSelectOptions(workspace_uuid, entry, obj){
            if(obj.hasOwnProperty('auxiliar_endpoint_attributes')){
                const selectOptions = [];
                const list = await this.getCustomReportListOptions({...obj.auxiliar_endpoint_attributes, workspaceUuid: workspace_uuid})
                list.forEach(element => {
                    selectOptions.push({
                        label : element.name,
                        id: element.code
                    })
                });
                this.extraData[entry].list = [...selectOptions];
            }
        },
        /**
         * Get closing options depending on whether the Network Starting Point field has any objects selected.
         * If so, we get the closures that are associated with the technical local.
         * If not, we get all closures from the workspace
         * @returns {Promise<void>}
         */
        async loadClosureOptions() {
            try {
                if (this.reportParameters[0].value) {
                let technicalLocal = await this.GET_TECHNICAL_LOCAL_WITH_LOGICAL_RELATIONS(
                    {
                    technicalLocalUUID: this.reportParameters[0].value,
                    workspaceUUID: this.selectedWorkspace,
                    includes: ["logicalrelationsclosures"]
                    }
                );
                this.closureOptions = technicalLocal["logicalrelationsclosures"];
                } else {
                this.closureOptions = await this.GET_ALL_OBJECTS_IN_GIVEN_WORKSPACE({
                    endpoint: "closures",
                    workspaceUUID: this.selectedWorkspace
                });
                }
            } catch (e) {
                console.error(e);
            }
        },
        getLabel(name){
            let label;
            if(this.extraData[name].label){
                label = this.extraData[name].label;
            }else{
                label = this.getFormattedLabel(name);
            }
            //check if is required
            if(this.extraData[name].required){
                label = `${label} *`
            }
            return label;
        },
        getFormattedLabel(rawLabel){
            const rawWord = rawLabel.replaceAll('_', ' ');
            const words = rawWord.split(" ");
            const formattedWord = words.map((word) => {
                return word[0].toUpperCase() + word.substring(1);
            }).join(" ");
            return formattedWord.replaceAll(' ', '');
        },
        /**
         * Normalizer for the list of closure options (so that the treeselect component can read it).
         * @param node
         * @returns {{id: *, label: (*|string)}}
         */
        normalizer(node) {
            return {
                id: node.cl_uuid,
                label: node.cl_label ? node.cl_label : "ID:" + node.cl_id
            };
        },
        //check if required input in extra data is empty
        requiredExtraDataIsEmpty(){
            let isEmpty;
            let isEmptyCounter = 0;
            let requiredFieldsNames = [];
            let fieldsAreRequired = false;
            this.extraDataNames.forEach(name => {
                if(this.extraData[name].required){
                    fieldsAreRequired = true;
                    requiredFieldsNames.push(name);
                }
            });
            requiredFieldsNames.forEach(name =>{
                if(!(!!this.extraData[name].value)){
                    isEmptyCounter++;
                }
            });
            isEmpty = isEmptyCounter !== 0;
            return {fieldsAreRequired, isEmpty};
        }
    }
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/CustomReport.vue